import React from 'react'
import Topsec from '../../Components/Dashboard/Topsec'
import QuickAction from '../../Components/Card/QuickAction'

function BillsPayment() {
  return (
    <div>
         <Topsec/>
         <QuickAction/>
    </div>
  )
}

export default BillsPayment